import { Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

// Plugin
import Swal from 'sweetalert2';

// Service
import { ApiService } from '../../shared/service/api.service';
import { GlobalService } from '../../shared/service/global.service';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styles: [
  ]
})
export class ContactUsComponent implements OnInit, OnDestroy{

  @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;
  dataBanner;
  send:boolean;
  captchaResponse = '';
  infoCaptcha = false;
  titleHasError:boolean;
  isLang;
  dataAbout = [];

  constructor( private apiService: ApiService, 
              private renderer: Renderer2,
              private globalService: GlobalService,
              private router: Router) { 
    this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getSubHeaderByLink/contact-us').subscribe(response => {
      if(response.success) {
        this.dataBanner = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });

    // category contact
    this.apiService.getDataApi('getCategoryContact').subscribe(response => {
      response.data.forEach((i, x) => {
        this.dataAbout.push({
          'id' : i.id,
          'text': i.title
        });
      });
    });

    // captcha
    this.addRecaptchaScript();

    this.renderer.addClass(document.body, 'select-ver3');
  }

  onSubmit(contactForm: NgForm){
    if(this.captchaResponse != ''){
      let body = contactForm.value;
      this.send = true;
      this.infoCaptcha = false;
      if(body.about && body.name && body.email && body.phone && body.address && body.company && body.fax && body.content){
        this.apiService.postDataApi('saveContact', body).subscribe(
          data => { 
            Swal.fire({
              icon: 'success',
              text:  data.message
            });
            this.send = false;
            contactForm.resetForm();
          },
          error => { 
            Swal.fire({
              icon: 'error',
              text: 'Failed, please try again!'
            });
            this.send = false;
          }
        ); 
        window['grecaptcha'].reset();
        this.captchaResponse = '';
      }
    }else{
      this.infoCaptcha = true;
    }
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6LeT670ZAAAAAJCzg17P5mvqFLAQO4Vw_IS-J_Ua',
      'callback': (response) => {
        this.captchaResponse = response;
      }
    });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
  
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptcha(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }

  validateTitle(value) {
    if (value == '') {
      this.titleHasError = true;
    } else {
      this.titleHasError = false;
    }
  }

  ngOnDestroy(){
    this.renderer.removeClass(document.body, 'select-ver3');
     /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open')
  }

}
